import React from 'react';
import { FlexColumn, Text } from 'core/components';
import { getAggregateTypeLabel, getAggregateUnitLabel } from 'app/util/aggregateLabels';

export default function Aggregate({ typeLabel, aggregate, ...rest }) {
  return (
    <FlexColumn>
      <Text as="div">{typeLabel || getAggregateTypeLabel({ aggregate, ...rest })}</Text>
      <Text muted fontWeight="normal">
        {getAggregateUnitLabel({ aggregate, ...rest })}
      </Text>
    </FlexColumn>
  );
}
